angular.module('swapick')
.directive('imagesGallery', imagesGallery)
.directive('fallbackSrc', function () {
  var fallbackSrc = {
    priority:100,
    link: function postLink(scope, iElement, iAttrs) {
      iElement.attr('src', iAttrs.fallbackSrc);
      let o = iAttrs.$observe('src', function(src) {
        iElement.attr('src', iAttrs.fallbackSrc);

        //on next frame, set src again
        ionic.requestAnimationFrame(function() {
          iElement.attr('src', src);
        });
        o();
      });

      iElement.bind('error', function() {
        angular.element(this).attr("src", iAttrs.fallbackSrc);
        iElement.removeAttr('fallback-src');
      });
    }
   }
   return fallbackSrc;
});

function imagesGallery($ionicModal){
    return {
        scope : { images : "=", imagesObject:"="},
        restrict: 'A',
        link: function (scope, iElement, iAttrs) {
            scope.modal = null;
            scope.galleryImages = [];

            if(iAttrs.images !== undefined ){
                scope.$watchCollection('images', (images)=>{
                    scope.currentIndex = images && images.length ? 0 : null;
                    scope.galleryImages = angular.copy(images);
                })
            }

            if(iAttrs.imagesObject !== undefined ){
                scope.$watch('imagesObject', (obj)=>{
                    let images = [];
                    if(obj.immagine) images.push(obj.immagine);
                    if(obj.altre_immagini){
                        images = images.concat(obj.altre_immagini || []);
                    }
                    scope.galleryImages = angular.copy(images);
                    scope.currentIndex = images && images.length ? 0 : null;
                }, true)
            }

            $ionicModal.fromTemplateUrl('templates/gallery-modal.html', {
                scope:scope
            }).then(m=>{
                scope.modal = m;
            })
            scope.closeModal = ()=>{
                scope.modal.hide()
            };
            scope.showModal = ()=>{
                scope.modal.show()
            };

            scope.$on("$destroy", ()=>{
                if(scope.modal){
                    scope.modal.remove();
                }
            })
            scope.setCurrent = (idx) => {
                scope.currentIndex = idx;
            }

            iElement.on('click', (evt) => {
                scope.showModal()
            })

        }
    };
}



// WEBPACK FOOTER //
// ./src/directives/images-gallery.js